import {
    ResourceFilterElement,
    ResourceFiltersSelectedItem,
} from "../../../../../shared/components/createOrder/createOrderTypes"
import { LocalCache, StorageKey } from "../../../../../shared/cache/LocalCache"

function isSelectedFilter(value: unknown): value is ResourceFiltersSelectedItem {
    if (typeof value !== "object" || value === null) return false
    const record = value as Record<string, unknown>
    return typeof record["identifier"] === "string" && Array.isArray(record["values"])
}

// Persist the applied filters (the Timeline filters are session-only, but here the client wants them remembered).
export function loadSavedFilters(key: StorageKey): ResourceFiltersSelectedItem[] {
    try {
        const saved: unknown = JSON.parse(LocalCache().get(key) ?? "[]")
        return Array.isArray(saved) ? saved.filter(isSelectedFilter) : []
    } catch {
        return []
    }
}

export function saveFilters(key: StorageKey, filters: ResourceFiltersSelectedItem[]) {
    LocalCache().set(key, JSON.stringify(filters))
}

// Saved chips keep their (possibly stale-language) label; refresh each value's label from the current options.
export function relocalizeSelectedFilters(
    filters: ResourceFiltersSelectedItem[],
    availableFilters: ResourceFilterElement[],
): ResourceFiltersSelectedItem[] {
    return filters.map((filter) => {
        const elementValues = availableFilters.find((candidate) => candidate.identifier === filter.identifier)?.values
        if (!elementValues) return filter
        return {
            ...filter,
            values: filter.values.map((value) => {
                const fresh = elementValues.find((option) => option.value === value.value)
                return fresh ? { ...value, key: fresh.key } : value
            }),
        }
    })
}
